import './src/main.css'
import Decoration4 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration4.name, Decoration4)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration4/index.js